<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getWeak } from '@/services/login';
import { agentDefault } from '@/services/set'
import { mapMutations } from 'vuex'
export default{
  created(){
    this.handleResize()
    this.getWeakFn()
    // 刷新场景下根据已缓存的渠道码恢复渠道样式
    this.setChannelTheme(sessionStorage.getItem('weidun_channel_code') || this.$store.state.channel.channelCode)
  },

  watch:{
    '$route':{
      handler(val){
        if(val.name === 'home' && val.params.channelCode){
          sessionStorage.setItem('weidun_channel_code',val.params.channelCode)
          this.getAgentDefault()
        }
        if(val.params && val.params.channelCode){
          this.setChannelTheme(val.params.channelCode)
        }
      }
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
    // 接收父页面通过 iframe postMessage 传入的文本，暂存到 store，由 ai.vue 消费
    window.addEventListener('message', this.handleIframeMessage);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('message', this.handleIframeMessage);
  },
  methods:{
    ...mapMutations('agent',['setDefaultAgent']),
    // 根据渠道码在 body 上挂载 channel-xxx 类，用于渠道自定义样式（styles/channel.scss）
    setChannelTheme(code){
      if(!code) return
      const classList = document.body.classList
      Array.from(classList).forEach(cls => {
        if(cls.indexOf('channel-') === 0){
          classList.remove(cls)
        }
      })
      classList.add(`channel-${code}`)
    },
    ...mapMutations('mobile',['setPc']),
    ...mapMutations('message',['setPendingMessage']),
    // 处理父页面 postMessage 传入的消息
    // 约定格式: { type: 'weidun_send', text: '要发送的文字' }
    handleIframeMessage(e) {
      // alert(JSON.stringify(e.data))
      const data = e.data
      if (data && typeof data === 'object' && data.type === 'weidun_send' && data.text) {
        this.setPendingMessage(data.text)
      }
    },

    handleResize() {
      if(window.innerWidth > 680){
        this.setPc(true)
      }else{
        this.setPc(false)
      }
    },

    async getAgentDefault(){
      let res = await agentDefault()
      if(res.code == 200 && res.data){
        this.setDefaultAgent(res.data)
      }
    },
    async getWeakFn() {
      const res = await getWeak();
      if(res.code === 200){
        sessionStorage.setItem('weakPassword',JSON.stringify(res.data))
      }
    },
  }
}
</script>

<style lang="scss">
p{
  margin: 0 !important;
}
.ant-modal-header{
  border-radius: 12px 12px 0 0 !important;
}
.ant-modal-footer{
  border-radius: 0 0 12px 12px !important;
}
.ant-modal-content{
  border-radius: 12px !important;
  overflow: hidden !important;
}
.ant-tabs-nav .ant-tabs-tab:hover{
  color: $base_color !important;
  background: $base_color_active !important;
}
.ant-modal-title{
  font-weight: 700 !important;
}
@media (max-width: 767px) {
  .ant-modal {
    max-width: calc(100vw - 50px) !important;
    margin: 8px auto;
  }
}
</style>
